/* 🤖 this file was generated by svg-to-ts */
export const matIconMan3: {
  name: 'man-3';
  data: string;
} = {
  name: 'man-3',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zm-2-5.249L14.248 4 12 6.248 9.75 4z"/></svg>`
};
